import { $RootTraffic } from '@lemon8/web-app-shared/atom';
import { atom } from 'jotai';

export const $EnableCici = atom((get) => {
  const { trafficPid } = get($RootTraffic);

  return trafficPid === 'website_cici';
});
